import { Component } from 'react';
import { DateTime } from 'common/utils/date';

class TakeawayDisplayClass extends Component {
  constructor(props) {
    super();
    this.state = {
      loading: false,
      error: false,
      ...props,
    };
    this.completeTakeaway = this.completeTakeaway.bind(this);
  }

  completeTakeaway(e, a) {
    const { id, completedAt } = this.props;
    const complete = e.target.checked;

    this.setState({ loading: true, error: false });
    $.ajax({
      url: `/api/v1/coaching/takeaway/${id}`,
      dataType: 'json',
      cache: false,
      type: 'PUT',
      contentType: 'application/json',
      data: JSON.stringify({ complete }),
      success: function (takeaway) {
        this.setState({ ...takeaway, loading: false });
      }.bind(this),
      error: function () {
        this.setState({
          completed: !!completedAt,
          loading: false,
          error: true,
        });
      }.bind(this),
    });
  }

  render(
    {
      text,
      completedAt,
      completedBy,
      createdAt,
      createdBy,
      sessionId,
      categoryName,
    } = this.state,
  ) {
    return (
      <div className="actions-and-kudo-display trends-table-actions">
        <div className="action-card" data-completed={!!completedAt}>
          <div className="takeaway-info">
            <div className="takeaway-text">{text}</div>
          </div>
          <div className="takeaway-details">
            <div className="takeaway-category">{categoryName}</div>
            <a
              className="takeaway-session-link"
              href={`/one_on_ones/${sessionId}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              Go to session
            </a>
          </div>
        </div>
        <div className="takeaway-status">
          <span>
            {completedAt ? completedBy : createdBy} •{' '}
            {DateTime.fromISO(completedAt || createdAt).toLocaleString(DateTime.DATETIME_MED)}
          </span>
        </div>
      </div>
    );
  }
}

export default TakeawayDisplayClass;
